export default __webpack_public_path__ + "static/media/access_denied_background.ee497519.png";